import React, { Fragment, useEffect } from "react";
import PropTypes from "prop-types";
import HeadSection from "./HeadSection";
import FeatureSection from "./FeatureSection";
// import PricingSection from "./PricingSection"; --- Uncomment this line if you want to use PricingSection
import SolutionsSection from "./SolutionsSection";
import WaitlistCard from "./waitlistSection"; // Import the WaitlistCard


function Home(props) {
  const { selectHome } = props;
  useEffect(() => {
    selectHome();
  }, [selectHome]);
  return (
    <Fragment>
      <HeadSection />
      <FeatureSection />
      <SolutionsSection />
      {/* <PricingSection /> //---Uncomment this line if you want to use PricingSection */}
      {/* Add the WaitlistCard here, providing the required props */}
      <div style={{ padding: "40px 0", backgroundColor: "#fdf6ee", display: "flex", justifyContent: "center" }}> {/* Optional: Wrapper for styling */}
        <div style={{ maxWidth: "600px", width: "100%", padding: "0 16px" }}> {/* Optional: Content constrainer */}
          <WaitlistCard 
            Icon={<img src={process.env.PUBLIC_URL + "/wolfie_round.png"} alt="Wolfe Logo" style={{ width: '50px', height: '50px' }} />} 
            color="#fdf6ee"  
            headline="Join Our BetaTesting Waitlist!" 
            text="Be among the first to experience Wolfe's AI mental wellness support. Limited beta spots available - secure your early access today" 
          />
        </div>
      </div>
    </Fragment>
  );
}

Home.propTypes = {
  selectHome: PropTypes.func.isRequired
};

export default Home;
